import React from 'react';
import { TypedMemo } from '../../../common/types';
import { useUserTokenDecoded } from '../../../../redux/slices/appInfo/hooks';
import { SMLUpgradeLockBanner } from '../../../music24/components/SMLUpgradeLockBanner/SMLUpgradeLockBanner';
import { SMLUpgradeFeature } from '../../../music24/config/music24PlanCapabilities';
import { ApiAccessCard } from './ApiAccessCard';
import { ApiDocsButton } from './ApiDocsButton';
import { AiAssistantsApiLink } from '../aiAssistants/AiAssistantsApiLink';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the API tab; each part uses its own slice of it */
import styles from './apiAccess.module.scss';
/* eslint-enable css-modules/no-unused-class */

/**
 * Settings → API. Gated on the Pro plan's `canAccessApi` capability — a
 * Free/Premium user sees the standard upgrade banner instead of the card.
 * The approved MCP clients moved to Settings → AI assistants (2026-10-11). One line points there,
 * on every plan.
 */
const ApiAccessSectionComponent: React.FC = () => {
  const userTokenDecoded = useUserTokenDecoded();
  const capabilities = userTokenDecoded?.licenseInfo?.smlCapabilities;
  const canAccessApi = capabilities?.canAccessApi === true;

  return (
    <section className={styles.panel}>
      {/* The page head (SettingsPageHead) shows the title "API access" and the description. The docs
       * link sits in the Quickstart head, so the first box starts level with the rail. */}
      {canAccessApi ? (
        <ApiAccessCard dailyBrowseCredits={capabilities?.dailyBrowseCredits} />
      ) : (
        <div className={styles.locked}>
          <SMLUpgradeLockBanner feature={SMLUpgradeFeature.apiAccess} />
          <div>
            <ApiDocsButton />
          </div>
        </div>
      )}

      <AiAssistantsApiLink />
    </section>
  );
};

export const ApiAccessSection = TypedMemo(ApiAccessSectionComponent);
